import gql from "graphql-tag";

const SUB_NEW_CLIENT_REGISTRATION_CHANGE = gql`
    subscription realtorClientRegistrationChange($registration_id: Int){
        realtorClientRegistrationChange(registration_id: $registration_id)
    }
`;

export default SUB_NEW_CLIENT_REGISTRATION_CHANGE;
